import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [state, setState] = useState({ status: "loading", message: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) return setState({ status: "error", message: "Missing verification token" });
    api.post("/auth/verify-email", { token })
      .then(({ data }) => { setState({ status: "ok", message: data.message }); sessionStorage.removeItem("cgland_dev_verify_link"); refreshUser(); })
      .catch((err) => setState({ status: "error", message: errorMessage(err) }));
  }, [params, refreshUser]);

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center grid-bg p-6">
      <div data-testid="verify-email-page" className="max-w-md w-full text-center rounded-2xl border bg-card p-10 shadow-xl fade-up">
        {state.status === "loading" && <Loader2 className="mx-auto animate-spin text-emerald-700" size={40} />}
        {state.status === "ok" && <CheckCircle2 className="mx-auto text-emerald-600" size={48} />}
        {state.status === "error" && <XCircle className="mx-auto text-red-500" size={48} />}
        <h1 className="mt-6 text-2xl font-extrabold tracking-tight">
          {state.status === "loading" ? "Verifying…" : state.status === "ok" ? "Email verified" : "Verification failed"}
        </h1>
        <p data-testid="verify-email-message" className="mt-2 text-muted-foreground">{state.message}</p>
        <Button asChild data-testid="verify-continue-button" className="mt-8 rounded-full bg-emerald-900 hover:bg-emerald-800 dark:bg-emerald-500 dark:text-slate-950"><Link to="/dashboard">Continue to dashboard</Link></Button>
      </div>
    </div>
  );
}
